import CallSettings from './callSettings.container';

export default CallSettings;
